import React from 'react';
import { useQuery } from "@apollo/client";
import moment from "moment";

import "./moment-locales";

import { GET_APP_PARAMS } from "graphql/query/local-store-gql";
import { GET_LANGUAGES } from "graphql/query/language-gql";
import { getEnabledLanguage } from "mock-data/translation/languages";
import { setLanguageOverride } from "components/service/translation-cache";

import { Menus } from "components/layout";
import { AppRoutes }   from "components/routes";
import { Suspense }    from "components/request-result";
import { useMe, useVarParam } from "components/use-hooks";

import './app.scss';


const localeMoment = moment;

const App = () => {

    const { loading, me, error } = useMe("cache-and-network", true),
          { data : languagesData } = useQuery(GET_LANGUAGES, {
              fetchPolicy: 'cache-and-network',
              nextFetchPolicy: 'cache-first'
          }),
          { data : { appParams } } = useQuery( GET_APP_PARAMS );
    const appVarParams = useVarParam();

    const extraClass = `${ appParams.appBlockClass.join(" ") }${ appParams.bottomBar ? " with-bottom-bar": "" }`;
    const translationLanguages = languagesData?.languages || appParams.translationLanguages || [];
    const userLanguage = me ? me.language_slug : null;
    const languageOverride = appParams.translationLanguageOverride;
    const validLanguageOverride = languageOverride && getEnabledLanguage(languageOverride, translationLanguages) ? languageOverride : null;
    const validUserLanguage = userLanguage && getEnabledLanguage(userLanguage, translationLanguages) ? userLanguage : null;
    const appLanguage = validLanguageOverride || validUserLanguage || "en";

    localeMoment.locale(appLanguage);

    React.useEffect(() => {
        document.documentElement.setAttribute("lang", appLanguage);
    }, [
        validLanguageOverride,
        validUserLanguage,
        appLanguage
    ]);

    React.useEffect(() => {
        if (!languageOverride || validLanguageOverride) return;

        setLanguageOverride(null);
        appVarParams.set({
            translationLanguageOverride: null
        });
    }, [
        appVarParams,
        languageOverride,
        validLanguageOverride
    ]);

    appVarParams.set({
        "moment" : localeMoment,
        "me" : me,
        "translationLanguages" : translationLanguages
    });

    return (
        <div className={ `app ${ extraClass }` }>
            <Suspense type="block" state={ { loading, error } }>
                <Menus.TopBar key="top-bar" />
                <main key="main-body">
                    <AppRoutes />
                </main>
                <Menus.BottomBar key="bottom-bar" />
            </Suspense>
        </div>
    );
};

export default App;
